import React, {Component} from 'react';
import {Empty} from "antd";
import {Scrollbars} from "react-custom-scrollbars";
import {connect} from "react-redux";
import _ from 'lodash';
import "./interview.css";

class NewsActivityPublishPlatform extends Component {

    constructor(props){
        super(props);
        
        this.state = {
            selectedPlatForm:[],
            mediaClassify: {},
        }
    }

    componentDidMount(){
        this.setSelectedPlatFormData(this.props.data);
       
    }
    setSelectedPlatFormData = (currentData) => {
        let selectedPlatForm = [];
        currentData.simpleMedias && currentData.simpleMedias.map((item) =>(
            selectedPlatForm.push({...item, checked: true})
        ));
        this.setState({
            selectedPlatForm
        }, ()=>{
            this.getCurrentSelectMedias(this.state.selectedPlatForm)
            this.classify(this.state.selectedPlatForm);
            this.props.getPublishData && this.props.getPublishData('all',this.state.selectedPlatForm)
        })
        
    }

    refreshData  = () => {
        let selectedPlatForm = [];
        this.props.data.simpleMedias && this.props.data.simpleMedias.map((item) =>(
            selectedPlatForm.push({...item, checked: true})
        ));
        this.setState({
            selectedPlatForm
        }, ()=>{
            this.getCurrentSelectMedias(this.state.selectedPlatForm);
            this.classify(this.state.selectedPlatForm);
            this.props.getPublishData && this.props.getPublishData('all',this.state.selectedPlatForm)
        })
    }

    classify = (simpleMedias) =>{
        let mediaClassify = {};
        simpleMedias && simpleMedias.map(item => {
            if(!mediaClassify["type_" + parseInt(item.platform)]){
                mediaClassify["type_" + parseInt(item.platform)] = [item];
            }else{
                mediaClassify["type_" + parseInt(item.platform)].push(item);
            }
        })
        this.setState({
            mediaClassify
        })
    };

    //获取当前已选择的媒体数组
    getCurrentSelectMedias = (data) => {
        let resultData = data.filter((item,index,self) => item.checked === true);
        this.props.getPublishData && this.props.getPublishData('other',resultData)
    }

   

    clickPlatForm = (item) => {
        let selectedPlatForm = _.cloneDeep(this.state.selectedPlatForm);
        selectedPlatForm.forEach((formItem, index) => {
            if(formItem.id === item.id){
                formItem.checked = !formItem.checked;
                return;
            }
        });
        this.setState({
            selectedPlatForm
        }, ()=> {
            this.getCurrentSelectMedias(this.state.selectedPlatForm)
            this.classify(this.state.selectedPlatForm);
        })
    }

    render() {
        let publishPlatformChunks = [];
        const { mediaClassify } = this.state;
        if(this.props.sysConfig){
            let platforms = JSON.parse(this.props.sysConfig.getValueByKey("sys.media.platform", "[]"));
            if(platforms && platforms.length > 0){
                let allClassifyMap = {};
                let icons = {};
                platforms.map(platform=>{
                    allClassifyMap["type_" + platform.code] = platform.name;
                    icons["type_" + platform.code] = platform.icon;
                });
                for(var attr in allClassifyMap){
                    if( mediaClassify[attr] && mediaClassify[attr].length > 0){
                        
                        publishPlatformChunks.push(<PublishPlatformChunk hasOperate = {this.props.hasOperate} clickPlatForm={this.clickPlatForm} icon={icons[attr]} name={allClassifyMap[attr]} data={mediaClassify[attr]}/>);
                    }
                }
            }
        }
        return (
            <div style={{backgroundColor:"#f4f6fc",padding:"20px 20px 0 20px",width:"100%"}}>
                <Scrollbars
                    autoHeight
                    autoHeightMax={400}
                >
                {
                   (Object.keys(mediaClassify)).length === 0 ? <Empty/>:publishPlatformChunks.map((item, index)=>{
                        return <div key={index} style={{width:"100%", backgroundColor:"#fff", padding:"32px 40px 10px 40px"}}>{item}</div>
                })}
                </Scrollbars>
            </div>
        );
    }
}
NewsActivityPublishPlatform.defaultProps = {
    data: {
        simpleMedias: [],
    }
};

class PublishPlatformChunk extends Component{
    
    shouldComponentUpdate(nextProps, nextState){
        return _.cloneDeep(nextProps.data) !== _.cloneDeep(this.props.data)
    }

    render() {
        return <div style={{width:"100%"}}>
            <div style={{marginBottom:"12px"}}>
                <img src={this.props.icon} width={40} height={40}/><span style={{marginLeft:"10px",color:"#727a8f"}}><b>{this.props.name}</b></span>
            </div>
            <div style={{width:"100%",background: "#f4f6fc",padding:"0 0 20px 20px",borderRadius: "6px",overflow:"auto"}}>
                {this.props.data && this.props.data.map((item, index)=>{
                    return <PublishPlatform hasOperate={this.props.hasOperate} clickPlatForm={this.props.clickPlatForm} item={item} key={index}/>
                })}
            </div>
            <div style={{clear:"both"}}></div>
        </div>
    }
}

class PublishPlatform extends Component{

    shouldComponentUpdate(nextProps, nextState){
        return _.cloneDeep(nextProps.item) !== _.cloneDeep(this.props.item)
    }
    
    render() {
        return <div onClick={this.props.hasOperate ? () => this.props.clickPlatForm(this.props.item) : null} className={ this.props.item.checked ? "selected-platform" : null} style={{float:"left", cursor:'pointer',padding:"10px 14px",marginTop:"20px",marginRight:"20px", backgroundColor: "#ffffff",borderRadius: "6px"}}>
            {this.props.item.name}
        </div>
    }
}

function mapStateToProps(state){
    return {
        sysConfig : state.systemReducer.config,
        
    }
}

export default connect(mapStateToProps,null, null, {forwardRef  : true})(NewsActivityPublishPlatform);